// src/components/home/HeroSlider.jsx
"use client";

import { useEffect, useState, useRef } from "react";

// ⬇️ IMPORTÁ TUS 3 IMÁGENES AQUÍ (ajustá las rutas a tus assets)
import imgCel from "../../assets/imgCel.png";      // chico viendo el teléfono
import imgAuto from "../../assets/imgAuto.png";         // auto en concesionaria
import imgCasa from "../../assets/imgCasa.png";         // pareja con notebook / casa

const slides = [
  {
    id: 1,
    img: imgCel,
    side: "left", // texto a la izquierda
    over: "left", // difuminado a la izquierda
    eyebrow: "Fácil y sencillo",
    title: "Solicitá tu crédito desde el celular",
    body:
      "Completá tu solicitud en minutos, sin papeles y desde donde estés. Seguimiento 100% online, transparente y seguro.",
    ctaText: "Iniciar solicitud",
    ctaHref: "#personales", 
  },
  {
    id: 2,
    img: imgCasa,
    side: "right",
    over: "right",
    eyebrow: "Hipotecarios Gamaan",
    title: "Tu casa propia más cerca",
    body:
      "Financiación pensada para tus metas: tasas competitivas, plazos flexibles y acompañamiento de punta a punta.",
    ctaText: "Ver créditos hipotecarios",
    ctaHref: "#hipotecarios",
  },
  {
    id: 3,
    img: imgAuto,
    side: "left",
    over: "left",
    eyebrow: "Créditos prendarios",
    title: "Tu próximo auto, hoy",
    body:
      "Elegí el vehículo, simulá tu cuota y obtené la mejor alternativa de financiación con aprobación ágil.",
    ctaText: "Conocer prendarios",
    ctaHref: "#prendarios", 
  },
];

export default function HeroSlider() {
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);

  // Auto-play (6s). Pausa al interactuar con flechas/puntos.
  useEffect(() => {
    start();
    return stop;
  }, [idx]);

  const start = () => {
    stop();
    timerRef.current = setTimeout(() => {
      setIdx((i) => (i + 1) % slides.length);
    }, 6000);
  };
  const stop = () => timerRef.current && clearTimeout(timerRef.current);

  const go = (n) => {
    stop();
    setIdx(((n % slides.length) + slides.length) % slides.length);
  };

  const prev = () => go(idx - 1);
  const next = () => go(idx + 1);

  return (
    <section className="relative w-full bg-[#003226]">
      <div className="relative h-[420px] md:h-[520px] lg:h-[560px] overflow-hidden">
        {/* Slides */}
        {slides.map((s, i) => {
          const active = i === idx;
          return (
            <div
              key={s.id}
              className={`absolute inset-0 transition-opacity duration-700 ease-out ${
                active ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
              }`}
            >
              {/* Imagen */}
              <img
                src={s.img}
                alt={s.title}
                className="h-full w-full object-cover"
                draggable="false"
              />

              {/* Difuminado (lado elegido) */}
              {s.over === "left" ? (
                <div className="pointer-events-none absolute inset-y-0 left-0 w-full md:w-[60%] bg-gradient-to-r from-[#003226]/95 via-[#003226]/70 to-transparent backdrop-blur-[2px]" />
              ) : (
                <div className="pointer-events-none absolute inset-y-0 right-0 w-full md:w-[60%] bg-gradient-to-l from-[#003226]/95 via-[#003226]/70 to-transparent backdrop-blur-[2px]" />
              )}

              {/* Texto */}
              <div
                className={`absolute inset-0 px-4 md:px-8 lg:px-10 flex items-center`}
              >
                <div
                  className={`text-white max-w-xl ${
                    s.side === "left" ? "ml-0 md:ml-4 lg:ml-10" : "ml-auto mr-0 md:mr-4 lg:mr-10"
                  }`}
                  style={{ textShadow: "0 1px 2px rgba(0,0,0,.25)" }}
                >
                  <div className="inline-block rounded-full bg-white/10 px-3 py-1 text-xs uppercase tracking-wider">
                    {s.eyebrow}
                  </div>
                  <h2 className="mt-3 text-2xl md:text-4xl font-extrabold leading-tight">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-sm md:text-base/relaxed text-white/90">
                    {s.body}
                  </p>
                  <div className="mt-5">
                    <a
                      href={s.ctaHref}
                      className="inline-flex items-center rounded-lg bg-[#DBC5A8] px-4 py-2 text-[#003226] font-semibold hover:bg-[#e6d6c0] transition-colors"
                    >
                      {s.ctaText}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* Controles */}
        <div className="pointer-events-none absolute inset-x-0 bottom-3 flex items-center justify-between px-3 md:px-6">
          <button
            onClick={prev}
            className="pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/30 text-white hover:bg-black/45 transition"
            aria-label="Slide anterior"
          >
            ‹
          </button>
          <div className="pointer-events-auto flex gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => go(i)}
                className={`h-2.5 w-2.5 rounded-full transition ${
                  i === idx ? "bg-white" : "bg-white/50 hover:bg-white/70"
                }`}
                aria-label={`Ir al slide ${i + 1}`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full bg-black/30 text-white hover:bg-black/45 transition"
            aria-label="Siguiente slide"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
}
